import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import CommunicationsView from './communications.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useCommunicationRoutes = () => (
  <Route
    path={pages.communications.path}
    element={
      <ProtectedRoute module="communications" checkAnySubmodule>
        <CommunicationsView />
      </ProtectedRoute>
    }
  >
    <Route
      path={pages.communications.path + '/:communicationSubRouteId'}
      element={
        <ProtectedRoute module="communications" checkAnySubmodule>
          <CommunicationsView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useCommunicationRoutes;
